export default __webpack_public_path__ + "static/media/large.24c93dcb.jpg";